export const crmCards = {
    campaignCard: {
        entity: 'campaign',
        path: 'campaign',
        titleBar: { mergeParams: ['name'], new: 'campaign.form.new.title' },
        cardTitle: {
            title: 'campaign.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'campaign.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'campaignConfirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }
            ]
        },
        width: '1024px',
        sections: [
            {
                id: 'campaign',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'campaign.form.name',
                        placeholder: 'campaign.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'code',
                        label: 'campaign.form.code',
                        placeholder: 'campaign.form.code.placeholder',
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'campaign.form.description',
                        placeholder: 'campaign.form.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'date',
                        id: 'startDate',
                        label: 'campaign.form.startDate',
                        required: true
                    },
                    {
                        type: 'date',
                        id: 'endDate',
                        label: 'campaign.form.endDate',
                        required: true
                    },
                    {
                        type: 'switch',
                        id: 'isActive',
                        label: 'campaign.form.isActive'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'campaignCard.campaign.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'campaign.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: 'Code: ${1}',
                                    mergeParams: ['code'],
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: 'Active: ${1}',
                                    mergeParams: ['isActive'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    contactCard: {
        entity: 'contact',
        path: 'contact',
        titleBar: { mergeParams: ['name'], new: 'contact.form.new.title' },
        cardTitle: {
            title: 'contact.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'contact.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'contactConfirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        fieldsLogic: ['customerGroup'],
        sections: [
            {
                id: 'contact',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'switchSelect',
                        id: 'companyTypeId',
                        displayField: 'companyTypeName',
                        label: 'contact.form.type',
                        entity: 'companyType',
                        valueMap: {
                            'companyTypeName': 'name',
                            'companyTypeId': 'id'
                        }
                    },
                    /*
                     * Whether this is someone we sell to, buy from, or both.
                     * It sits at the top rather than inside the attributes modal
                     * because it is what every contact picker in the app filters
                     * on — and because a contact created on the fly from a
                     * supplier picker has to be able to say so before it is
                     * saved. See the default in dataRoutes.calculateDefaultValue.
                     */
                    {
                        type: 'switchSelect',
                        id: 'contactType',
                        displayField: 'contactTypeName',
                        label: 'contact.form.contactType',
                        entity: 'contactType',
                        valueMap: {
                            'contactType': 'id',
                            'contactTypeName': 'name'
                        }
                    },
                    /*
                     * A company's name doubles as a registry lookup (task 39.01):
                     * typing a name or registration number in a country with a
                     * CompanyInfo provider offers matches, and picking one fills
                     * the name, tax id and address. A person is not in a company
                     * registry, so for a person it is a plain text field.
                     */
                    {
                        type: 'companyLookup',
                        id: 'name',
                        parameter: 'country',
                        label: 'contact.form.name',
                        placeholder: 'contact.form.name.lookup.placeholder',
                        valueMap: {
                            'name': 'name',
                            'taxId': 'companyId',
                            'address_street': 'address.street',
                            'address_postCode': 'address.postalCode',
                            'address_city': 'address.city'
                        },
                        required: true,
                        conditionals: [
                            {
                                condition: { field: 'companyTypeId', operator: 'equals', value: 'person' },
                                set: { type: 'text', placeholder: 'contact.form.name.placeholder' },
                                unset: ['parameter', 'valueMap']
                            }
                        ]
                    },
                    {
                        type: 'email',
                        id: 'email',
                        label: 'contact.form.email',
                        placeholder: 'contact.form.email.placeholder'
                    },
                    {
                        type: 'text',
                        id: 'taxId',
                        label: 'contact.form.taxId',
                        placeholder: 'contact.form.taxId.placeholder'
                    },
                    /*
                     * The EU VAT ID and its VIES check. An invoice copies both
                     * when this contact is picked; reverse charge needs 'valid'.
                     * A valid check offers to overwrite the contact's name,
                     * address and country with what VIES has registered.
                     */
                    {
                        type: 'vatChecker',
                        id: 'vatId',
                        label: 'contact.form.vatId',
                        placeholder: 'contact.form.vatId.placeholder',
                        valueMap: {
                            'name': 'name',
                            'address_street': 'addressParts.street',
                            'address_postCode': 'addressParts.postalCode',
                            'address_city': 'addressParts.city',
                            'country': 'country',
                            'countryName': 'countryName'
                        },
                        condition: { field: 'companyTypeId', operator: 'notEquals', value: 'person' }
                    },
                    {
                        type: 'modal',
                        id: 'addressModal',
                        control: {
                            type: 'text',
                            id: 'addressModal',
                            label: 'contact.form.address',
                            placeholder: 'contact.form.address.placeholder'
                        },
                        descriptions: [
                            {
                                type: 'field',
                                field: 'address_street'
                            },
                            {
                                type: 'text',
                                text: ', '
                            },
                            {
                                type: 'field',
                                field: 'address_postCode'
                            },
                            {
                                type: 'text',
                                text: ' '
                            },
                            {
                                type: 'field',
                                field: 'address_city'
                            }
                        ],
                        modalForm: {
                            id: 'contactAddress',
                            elements: [
                                {
                                    type: 'text',
                                    id: 'address_street',
                                    label: 'contact.form.address',
                                    placeholder: 'contact.form.address.street',
                                    focus: true,
                                    fgMargin: '1.5rem',
                                    autoComplete: 'address-line1'
                                },
                                {
                                    type: 'group',
                                    id: 'addressPostCodeCity',
                                    label: 'contact.form.address',
                                    focus: false,
                                    fields: [
                                        {
                                            type: 'text',
                                            id: 'address_postCode',
                                            placeholder: 'contact.form.address.postcode',
                                            autoComplete: 'postal-code'
                                        },
                                        {
                                            type: 'text',
                                            id: 'address_city',
                                            placeholder: 'contact.form.address.city',
                                            focus: false,
                                            autoComplete: 'address-level2'

                                        },

                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'country',
                        id: 'country',
                        displayField: 'countryName',
                        label: 'all.country',
                        name: 'country',
                        valueMap: {
                            'country': 'id',
                            'countryName': 'name',
                        },
                        defaultType: 'country'
                    },
                    {
                        type: 'modal',
                        id: 'customerAttributesModal',
                        control: {
                            type: 'text',
                            id: 'customerAttributes',
                            label: 'contact.form.attributes',
                            placeholder: 'contact.form.attributes.placeholder'
                        },
                        descriptions: [
                            {
                                type: 'label',
                                text: 'contact.form.attributes.label.group'
                            },
                            {
                                type: 'field',
                                field: 'customerGroup'
                            },
                            {
                                type: 'label',
                                text: 'contact.form.attributes.label.locale'
                            },
                            {
                                type: 'field',
                                field: 'currency'
                            },
                            {
                                type: 'text',
                                text: ' , '
                            },
                            {
                                type: 'field',
                                field: 'languageName'
                            }
                        ],
                        modalForm: {
                            id: 'contactCustomerAttributes',
                            elements: [
                                {
                                    type: 'hconnect',
                                    id: 'customerGroup',
                                    displayField: 'customerGroup',
                                    parentId: 'parentId',
                                    label: 'contact.form.attributes.customerGroup',
                                    placeholder: 'contact.form.attributes.customerGroup.placeholder',
                                    modalTitle: "contact.form.attributes.customerGroup.modal.title",
                                    entity: 'customerGroup',
                                    parentField: { field: 'type', value: 'normal' },
                                    valueMap: {
                                        'customerGroup': 'id',
                                    },
                                    options: { withHeaders: true },
                                    required: true,
                                    linkedFields: ['customerGroup']
                                },
                                {
                                    type: "currency",
                                    id: 'currency',
                                    displayField: 'currency',
                                    parameter: "date",
                                    label: 'contact.form.attributes.currency',
                                    placeholder: 'contact.form.attributes.currency.placeholder',
                                    modalTitle: "contact.form.attributes.currency.modal.title",
                                    entity: 'currency',
                                    valueMap: {
                                        'currency': 'id',
                                        'currencyName': 'name',
                                    },
                                    options: { withHeaders: false, displayId: true },
                                    required: true,
                                    autoComplete: 'price-code-currency'
                                },
                                {
                                    type: "select",
                                    id: "language",
                                    displayField: "languageName",
                                    label: "contact.form.attributes.language",
                                    placeholder: "contact.form.attributes.language.placeholder",
                                    modalTitle: "contact.form.attributes.language.modal.title",
                                    entity: "language",
                                    valueMap: {
                                        language: "id",
                                        languageName: "name",
                                    },
                                    options: { withHeaders: false },
                                    required: true
                                },
                                {
                                    type: 'connect',
                                    id: 'priceListId',
                                    displayField: 'priceListId',
                                    label: 'contact.form.priceList',
                                    placeholder: 'contact.form.priceList.placeholder',
                                    modalTitle: "contact.form.priceList.modal.title",
                                    entity: 'priceList',
                                    valueMap: {
                                        'priceListId': 'id',
                                        'priceListName': 'idName'
                                    },
                                    options: { withHeaders: true },
                                    required: true,
                                    linkedFields: ['currency']
                                },
                            ]
                        }
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactCard.contact.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'email',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['address_street', 'address_postCode', 'address_city', 'countryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }]
    },

    contactPersonCard: {
        entity: 'contactPerson',
        path: 'contact/:id/contactPerson',
        titleBar: { mergeParams: ['name'], new: 'contactPerson.form.new.title' },
        cardTitle: {
            title: 'contact.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'contact.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'contactPersonConfirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'contact.person',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'contactPerson.form.name',
                        placeholder: 'contactPerson.form.name.placeholder',
                    },
                    {
                        type: 'email',
                        id: 'email',
                        label: 'contactPerson.form.email',
                        placeholder: 'contactPerson.form.email.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactPersonCard.person.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'email',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]

                }
            }]
    },

    customerGroupCard: {
        entity: 'customerGroup',
        path: 'customerGroup',
        titleBar: { mergeParams: ['id'], new: 'customerGroup.form.new.title' },
        cardTitle: {
            title: 'customerGroup.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'customerGroup.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }
            ]
        },
        width: '1024px',
        sections: [
            {
                id: 'customerGroup',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'code',
                        id: 'id',
                        label: 'customerGroup.form.code',
                        placeholder: 'customerGroup.form.code.placeholder',
                        required: true,
                        maxLen: 100,
                        uppercase: "true", //Must be string to avoid DOM Error,
                        // Editable on create, read-only once the code is the record's
                        // identity. `$mode` also has 'view' and 'read', so the union
                        // condition keeps this hidden there as both halves used to be.
                        condition: { field: '$mode', operator: 'in', value: ['new', 'edit'] },
                        conditionals: [
                            {
                                condition: { field: '$mode', operator: 'equals', value: 'edit' },
                                set: { type: 'text-readOnly' },
                                unset: ['maxLen', 'uppercase']
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'customerGroup.form.description',
                        placeholder: 'customerGroup.form.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'switchSelect',
                        id: 'type',
                        displayField: 'typeName',
                        label: 'customerGroup.form.type',
                        entity: 'groupType',
                        valueMap: {
                            'typeName': 'name',
                            'type': 'id'
                        }
                    },
                    {
                        type: 'connect',
                        id: 'parentId',
                        displayField: 'parentId',
                        label: 'customerGroup.form.parentId',
                        placeholder: 'customerGroup.form.parentId.placeholder',
                        modalTitle: "customerGroup.form.parentId.modal.title",
                        entity: 'customerGroup',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'type', value: 'normal' }]
                        },
                        valueMap: {
                            'parentId': 'id',
                        },
                        options: { withHeaders: true },
                        required: true,
                        condition: { field: 'type', operator: 'equals', value: 'subGroup' },
                        linkedFields: ['type']

                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'customerGroupCard.customerGroup.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'customerGroup.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: 'Code: ${1}',
                                    mergeParams: ['id'],
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    interactionCard: {
        entity: 'interaction',
        path: 'contact/:id/interaction',
        titleBar: { mergeParams: ['title'], new: 'interaction.form.new.title' },
        cardTitle: {
            title: 'contact.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'contact.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'interactionConfirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'contact.interaction',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'date',
                        id: 'date',
                        label: 'interaction.form.date',
                        placeholder: 'interaction.form.date.placeholder',
                        defaultType: 'date'
                    },
                    {
                        type: 'text',
                        id: 'title',
                        label: 'interaction.form.title',
                        placeholder: 'interaction.form.title.placeholder',
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'interaction.form.description',
                        placeholder: 'interaction.form.description.placeholder',
                        required: true,
                        rows: 4
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'interactionCard.interaction.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'title',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'title',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }]
    },
}
